import { LogIn, Settings, MessageCircle } from 'lucide-react';

const steps = [
  {
    number: 1,
    icon: LogIn,
    title: 'Sign In',
    description: 'One-click Google login to get started instantly'
  },
  {
    number: 2,
    icon: Settings,
    title: 'Set Preferences',
    description: 'Choose your language and customize video filters'
  },
  {
    number: 3,
    icon: MessageCircle,
    title: 'Start Chatting',
    description: 'Click Next to meet someone new from around the world'
  }
];

export function HowItWorks() {
  return (
    <section className="py-20 px-4 bg-[#151D2C]">
      <div className="max-w-4xl mx-auto">
        <h2 className="text-3xl md:text-4xl font-bold text-white text-center mb-4">
          How It Works
        </h2>
        <p className="text-gray-400 text-center mb-12">
          Get started in three simple steps
        </p>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
          {steps.map((step) => (
            <div key={step.number} className="text-center">
              <div className="relative inline-flex items-center justify-center mb-4">
                <div className="w-16 h-16 bg-[#11B981]/10 rounded-full flex items-center justify-center">
                  <step.icon className="w-7 h-7 text-[#11B981]" />
                </div>
                <span className="absolute -top-2 -right-2 w-7 h-7 bg-[#11B981] rounded-full flex items-center justify-center text-white font-bold text-sm">
                  {step.number}
                </span>
              </div>
              <h3 className="text-xl font-semibold text-white mb-2">
                {step.title}
              </h3>
              <p className="text-gray-400">
                {step.description}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
